export default __webpack_public_path__ + "static/media/tag-toggle.b09c0acb.svg";